module.exports = [
 {
  "start": 41,
  "end": 2959,
  "text": "Pixelwald Forest Mutterplate is made of "
 },
 {
  "start": 3000,
  "end": 5250,
  "text": "3000 LED hanging lights. "
 },
 {
  "start": 5458,
  "end": 7166,
  "text": "Each pixel is programmed "
 },
 {
  "start": 7333,
  "end": 9708,
  "text": "so that it knows exactly where it is, "
 },
 {
  "start": 9792,
  "end": 12750,
  "text": "and the whole is playing a 3D image."
 },
 {
  "start": 13250,
  "end": 15417,
  "text": "The free-hanging pixels not only "
 },
 {
  "start": 15500,
  "end": 17458,
  "text": "resemble the oxygen bubbles "
 },
 {
  "start": 17542,
  "end": 20083,
  "text": "emitted by sea grass but also "
 },
 {
  "start": 20166,
  "end": 22792,
  "text": "try to reconcile the different qualities "
 },
 {
  "start": 22875,
  "end": 27583,
  "text": "of lights we are exposed to – for example artificial lights, "
 },
 {
  "start": 27708,
  "end": 29417,
  "text": "warm lights, big bulbs, "
 },
 {
  "start": 29583,
  "end": 31959,
  "text": "the cooler light of the many screens "
 },
 {
  "start": 32041,
  "end": 34333,
  "text": "around and mostly in front of us, "
 },
 {
  "start": 34417,
  "end": 36500,
  "text": "the sparks in the synaptic clefts "
 },
 {
  "start": 36625,
  "end": 39250,
  "text": "where nerve cells pass via an electronic "
 },
 {
  "start": 39291,
  "end": 41875,
  "text": "or chemical signal to another neuron, "
 },
 {
  "start": 42208,
  "end": 43792,
  "text": "and finally the sunlight "
 },
 {
  "start": 43875,
  "end": 46291,
  "text": "in its different temperatures according "
 },
 {
  "start": 46333,
  "end": 48917,
  "text": "to the daytime and ones position "
 },
 {
  "start": 48959,
  "end": 49917,
  "text": "on the planet. "
 },
 {
  "start": 50583,
  "end": 52792,
  "text": "With Pixelwald I wanted to try "
 },
 {
  "start": 52875,
  "end": 54792,
  "text": "to bring these dimensions together "
 },
 {
  "start": 54875,
  "end": 57166,
  "text": "by making them apparent and visible. "
 },
 {
  "start": 57625,
  "end": 58834,
  "text": "I wanted to play with them "
 },
 {
  "start": 58917,
  "end": 61417,
  "text": "and explode the flatness of the screens "
 },
 {
  "start": 61500,
  "end": 64500,
  "text": "into the space and let people wander "
 },
 {
  "start": 64583,
  "end": 65834,
  "text": "through the pixels, "
 },
 {
  "start": 65917,
  "end": 67500,
  "text": "as though they could wander "
 },
 {
  "start": 67583,
  "end": 68583,
  "text": "through a brain."
 }
]


// WEBPACK FOOTER //
// ./src/Rist/content/tourWorks/room5/audio1/05_MCA Pixelworld.js